import { render, staticRenderFns } from "./confirm-payment.vue?vue&type=template&id=8c3aa65c&scoped=true&"
import script from "./confirm-payment.vue?vue&type=script&lang=ts&"
export * from "./confirm-payment.vue?vue&type=script&lang=ts&"
import style0 from "./confirm-payment.vue?vue&type=style&index=0&id=8c3aa65c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3aa65c",
  null
  
)

export default component.exports